import { useCallback, useEffect, useState } from 'react';
import { LEADERSHIP_TIER, isLeadershipViewerTier } from '@/constants/leadership-tier';
import { fetchMe } from '@/services/api/me';
import type { LeadershipTier } from '@/types/user';

export function useLeadershipTier() {
  const [leadershipTier, setLeadershipTier] = useState<LeadershipTier | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const profile = await fetchMe();
      setLeadershipTier(profile.leadershipTier);
    } catch {
      setLeadershipTier(LEADERSHIP_TIER.NONE);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const isLeadershipViewer = isLeadershipViewerTier(leadershipTier);

  const canViewLeadershipOversight = isLeadershipViewer;

  const showLeadershipMemberTab = isLeadershipViewer;
  const isTopLeader = isLeadershipViewer;

  return {
    leadershipTier,
    loading,
    canViewLeadershipOversight,
    showLeadershipMemberTab,
    isTopLeader,
    reload,
  };
}
